import { UsersAndUserGroupsDataModel } from "../UserGroupsManagement/userGroupsManagement";
import { environmentHttpClient as http } from "client/Api/httpClient";
import { UserAndUserGroupIdsModel } from "client/Api/Workspace/workspace";

export type EditHubItemCategoryPermissionModel = {
	everyoneHasAccess: boolean;
	whoHasAccess: UserAndUserGroupIdsModel;
	editors: UserAndUserGroupIdsModel;
	owners: UserAndUserGroupIdsModel;
};

export type BaseEditHubItemCategoryModel = {
	name: string;
	description: string;
	permissions: EditHubItemCategoryPermissionModel;
	canInformationBeChanged: boolean;
};

export type AnnouncementEditHubItemCategoryModel = BaseEditHubItemCategoryModel & {
	kind: HubItemKind.Announcement;
};

export type EventEditHubItemCategoryModel = BaseEditHubItemCategoryModel & {
	kind: HubItemKind.Event;
};

export type KnowledgeItemEditHubItemCategoryModel = BaseEditHubItemCategoryModel & {
	kind: HubItemKind.KnowledgeItem;
	pageContent: string | null;
	imageId: string | null;
	supportedImageTypes: readonly string[];
	maxImageSize: number;
};

export type EditHubItemCategoryModel =
	| AnnouncementEditHubItemCategoryModel
	| EventEditHubItemCategoryModel
	| KnowledgeItemEditHubItemCategoryModel;

export type EditHubItemCategoryPageModel = {
	usersAndUserGroupsData: UsersAndUserGroupsDataModel;
	category: EditHubItemCategoryModel;
};

export type KnowledgeItemDisplayInfoModel = {
	image: OptionalModel<Base64FileUriUploadModel | null>;
	pageContent: string | null;
};

export type HubItemCategoryInformationSaveModel = {
	name: string;
	description: string;
	knowledgeItemDisplayInfo: KnowledgeItemDisplayInfoModel | null;
};

export interface HubItemCategorySaveModel {
	information: OptionalModel<HubItemCategoryInformationSaveModel>;
	permissions: EditHubItemCategoryPermissionModel;
}

export interface HubItemCategorySaveResult {
	categoryId: number;
}

export const enum HubItemKind {
	Announcement = 1,
	KnowledgeItem = 2,
	Event = 3
}
export type HubItemCategoryPermissionModel = {
	canDelete: boolean;
	canUpdatePermissions: boolean;
	canUpdateInformation: boolean;
};

export function getCreateModel(
	kind: HubItemKind,
	signal?: AbortSignal
): Promise<EditHubItemCategoryPageModel> {
	return http.get<EditHubItemCategoryPageModel>(
		`HubItemCategories/${kind}/GetCreateModel`,
		undefined,
		{ signal }
	);
}

export function getUpdateModel(
	id: number,
	signal?: AbortSignal
): Promise<EditHubItemCategoryPageModel> {
	return http.get<EditHubItemCategoryPageModel>(
		`HubItemCategories/GetUpdateModel/${id}`,
		undefined,
		{ signal }
	);
}

export function add(
	kind: HubItemKind,
	hubItemCategory: HubItemCategorySaveModel
): Promise<HubItemCategorySaveResult> {
	return http.post<HubItemCategorySaveResult>(
		`HubItemCategories/${kind}`,
		hubItemCategory
	);
}

export function update(
	id: number,
	hubItemCategory: HubItemCategorySaveModel
): Promise<void> {
	return http.put<void>(
		`HubItemCategories/${id}`,
		hubItemCategory
	);
}

export function deleteCategories(ids: readonly number[], signal?: AbortSignal): Promise<void> {
	return http.delete<void>("HubItemCategories", ids, { signal });
}
